import { render, staticRenderFns } from "./entity-pills.vue?vue&type=template&id=0f60c9b0&"
import script from "./entity-pills.ts?vue&type=script&lang=ts&"
export * from "./entity-pills.ts?vue&type=script&lang=ts&"
import style0 from "./entity-pills.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports